<template>
  <div :class="cssClass">
    <v-autocomplete
      :value="value"
      v-bind="$attrs"
      :items="contactsList"
      :return-object="false"
      item-value="id"
      item-text="fullTitle"
      @input="onInput"
    >
      <template v-slot:item="{ item }">
        <div class="p-event-contact-select-list__item">
          <template v-if="isPromoterOrCopromoterField">
            <span v-if="isPromoterOrCopromoterField && item.company"
                  class="p-event-contact-select-list__item__company"
                  :class="{ 'font-weight-bold': item.isMember }">{{ item.company }}</span>
            <span class="p-event-contact-select-list__item__display-name"
                  :class="{ 'font-weight-bold': item.isMember, 'mod-font-small': isPromoterOrCopromoterField && item.company}">{{ item.displayName }}</span>
          </template>
          <template v-else>
            <span>{{ item.fullTitle}}</span>
          </template>
        </div>
      </template>
      <template v-slot:append-item>
        <v-divider></v-divider>
        <div class="p-list-add-item-link" @click="editContactDialog = true">
          {{ $t('contact.addNewContact') }}
        </div>
      </template>
    </v-autocomplete>

    <contact-edit-dialog
      :dialog.sync="editContactDialog"
      :contact="null"
      @add="onContactAdded"
    ></contact-edit-dialog>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

import ContactEditDialog from '@/views/Contacts/ContactEditDialog'


export default {
  inheritAttrs: false,


  components: {
    ContactEditDialog
  },


  props: {
    value: [Object, String],
    cssClass: String,
    isPromoterOrCopromoterField: {
      type: Boolean,
      default: false
    }
  },


  data () {
    return {
      editContactDialog: false
    }
  },


  computed: {
    ...mapGetters('contact', ['shortContactsForProject']),
    ...mapGetters('project', ['currentProjectId']),

    contactsList () {
      const contactsList = this.shortContactsForProject(this.currentProjectId).map(el => {
        let fullTitle = ''
        if (this.isPromoterOrCopromoterField) {
          fullTitle = el.company ? `${el.company} ${el.displayName}` : el.displayName
        } else {
          fullTitle = el.displayName
        }
        return {
          ...el,
          fullTitle
        }
      })
      return contactsList
    }
  },


  methods: {
    onInput (value) {
      this.$emit('input', value)
    },

    onContactAdded (contact) {
      this.$emit('input', contact.id)
    },

    removeMember (id) {
      const i = this.value.findIndex(x => x.contactId === id)
      this.value.splice(i, 1)
      this.$emit('input', this.value)
    }
  }
}
</script>
